const videoPlayers = document.querySelectorAll('[data-video-player]');

videoPlayers.forEach((vp) => {
  const overlay = vp.querySelector('.video-player-overlay');
  overlay?.addEventListener('click', (e) => {
    e.preventDefault();
    vp.classList.remove('awaiting-input');
    playVideo(vp);
  });

  if(vp.querySelector('video').hasAttribute('autoplay')){
    vp.classList.add('is-playing');
  }
});

function playVideo(vp) {
  const video = vp.querySelector('video');

  if (video.paused) {
    vp.classList.add('is-playing');
    setTimeout(() => {
      video.play();
    }, 70);
  } else {
    vp.classList.remove('is-playing');
    video.pause();
  }
}
